import { FC } from "react";
import Link from "next/link";
import CloseIcon from "@mui/icons-material/Close";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import Button from "@mui/material/Button";
import PersonIcon from "@mui/icons-material/Person";
import { LanguageSelector } from "./LanguageSelector";
import { ButtonMui } from "../button/ButtonMui";
import { ButtonArrow } from "@/components/navbar/svg/ButtonArrow";
import * as Styled from "./menu.styles";

interface MenuMobileProps {
  isOpen: boolean;
  handleOpenMenu: () => void;
  theme?: string;
}

const sxCloseIcon = {
  color: "var(--on-surface-light)",
  cursor: "pointer",
  "&:hover": {
    color: "var(--on-surface-light)",
  },
};

const sxToggleButtonGroupe = {
  gap: "1.875rem",
  fontWeight: "400 !important",
  "& .MuiToggleButton-root": {
    color: "var(--on-surface-light)",
    border: "none",

    "&.Mui-selected": {
      color: "var(--on-surface-light)",
      fontWeight: "600 !important",
      backgroundColor: "unset",
    },
  },
};

export const MenuMobile: FC<MenuMobileProps> = ({ isOpen, handleOpenMenu, theme }) => {
  return (
    <Styled.MenuMobileContainer isOpen={isOpen} theme={theme}>
      <Styled.InnerContainer>
        <Styled.CloseIcon theme={theme}>
          <CloseIcon sx={sxCloseIcon} fontSize={"large"} onClick={handleOpenMenu} />
        </Styled.CloseIcon>
        {/* <div>
          <LanguageSelector
            theme={theme}
            selectorStyle={sxToggleButtonGroupe}
          />
        </div> */}
        <Styled.SelectorsContainer>
          {/* <Styled.TabSelector theme={theme} className="display-small">
            <Link href="/freetrial">Free trial</Link>
          </Styled.TabSelector> */}
          <Styled.TabSelector theme={theme} className="display-small">
            <Link href="/contact">Contact</Link>
          </Styled.TabSelector>
        </Styled.SelectorsContainer>
        <Styled.ButtonsContainer>
          <ButtonMui variant="contained" size="medium" color={theme === "dark" ? "secondary" : "primary"} endIcon={<ButtonArrow />}>
            <Link href="/freetrial">Start a free trial</Link>
          </ButtonMui>
          <ButtonMui variant="text" size="medium" color={theme === "dark" ? "secondary" : "primary"} startIcon={<PersonIcon />}>
            <a href="https://app.cellectenergy.com/" rel="noopener noreferrer" target="_blank">
              Login
            </a>
          </ButtonMui>
        </Styled.ButtonsContainer>
      </Styled.InnerContainer>
    </Styled.MenuMobileContainer>
  );
};
